var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup629(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.041,
    height: 22.041,
    viewBox: "0 0 22.041 22.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(-322.787 -115.48)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 29.17,
    transform: "translate(323.494 136.813) rotate(-45)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 29.17,
    transform: "translate(323.494 116.187) rotate(45)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup629);
export default __webpack_public_path__ + "static/media/Group-629.0d27986a6452319228b7450a6ad21a87.svg";
export { ForwardRef as ReactComponent };